export default "__VITE_ASSET__CGiWjwul__"